import { useIdentityAuth } from './use-auth';

export const useUserPreferences = () => {
  const auth = useIdentityAuth();

  const preferences = auth.user?.profile?.pref;

  return {
    ...preferences,
  };
};
